<template>
  <v-layout row wrap justify-space-around fill-height align-center>
    <v-flex xs12 sm6 md4>
      <v-menu
        v-model="menu.m1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :label="titleDate"
            prepend-icon="event"
            readonly
            v-on="on"
            :value="momentFormatStartDate"
            outline
            :error-messages="errorMessages"
          ></v-text-field>
        </template>
        <v-date-picker
          header-color="primary"
          color="secondary"
          v-model="date"
          @input="menu.m1 = false"
          locale="es-419"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 sm6 md4>
      <v-menu
        ref="time"
        v-model="menu.m2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="momentFormatStartTime"
            :label="titleTime"
            prepend-icon="access_time"
            readonly
            v-on="on"
            outline
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu.m2"
          v-model="time"
          full-width
          @click:minute="$refs.time.save(time)"
          color="secondary"
          header-color="primary"
          format="24hr"
        ></v-time-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  props: [
    "titleDate",
    "titleTime",
    "errorMessages",
    "valueDate",
    "valueTime",
    "value"
  ],
  data: () => ({
    menu: {
      m1: false,
      m2: false
    },
    date: null,
    time: null,
    dateObject: null
  }),
  watch: {
    value() {
      if (this.value == "") {
        this.date = null;
        this.time = null;
        this.dateObject = null;
      }
    },
    date() {
      if (this.date) {
        if (this.time) {
          this.dateObject = new Date(this.date + " " + this.time);
        } else {
          this.dateObject = new Date(this.date + " 00:00");
        }
      }
      this.$emit("input", this.dateObject);
    },
    time() {
      if (this.date) {
        if (this.time) {
          this.dateObject = new Date(this.date + " " + this.time);
        } else {
          this.dateObject = new Date(this.date + " 00:00");
        }
      }
      this.$emit("input", this.dateObject);
    }
  },
  computed: {
    momentFormatStartDate() {
      if (this.date != null) {
        return moment(this.date).format("DD/MM/YYYY");
      }
      return "";
    },
    momentFormatStartTime() {
				if (this.dateObject == null) {
					if (this.time != null) {
						return moment(this.date).format("DD/MM/YYYY");
					}
				} else {
					return moment(this.dateObject).format("HH:mm");
				}
				return "";
			}
  }
};
</script>

<style>
</style>
